import { Button as AntButton, Modal } from "antd";
import { FC } from "react";
import { useTranslation } from 'react-i18next';

interface IProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
}

const ShowRublic3Modal: FC<IProps> = ({
  visible,
  setVisible,
}) => {
  const { t } = useTranslation();
  return (
    <Modal
      title="Rubric 3 Guide"
      visible={visible}
      width={750}
      onCancel={() => setVisible(false)}
      footer={[
        <div className='comm-btn__area justify-content-center'>
          <AntButton key="cancel" className='btn-basic gray' onClick={() => setVisible(false)}>
            {t('common.button.close')}
          </AntButton>
        </div>
      ]}
    >
      <table className="table table-bordered">
        <tbody>
          <tr>
            <th className="text-center align-middle font-weight-bold">Rubric 3</th>
            <td className="text-center align-middle">Listening</td>
            <td className="text-center align-middle">Reach Up</td>
            <td className="text-center align-middle">
              Class Discussion
            </td>
            <td>
              - Comprehension Skills<br />
              - Discourse<br />
              - Language Use<br />
              - Participation
            </td>
          </tr>
        </tbody>
      </table>

      <table className="table table-bordered">
        <tr>
          <td />
          <th className="text-center font-weight-bold">Needs Improvement<br />1</th>
          <th className="text-center font-weight-bold">Fair<br />2</th>
          <th className="text-center font-weight-bold">Good<br />3</th>
          <th className="text-center font-weight-bold">Great<br />4</th>
          <th className="text-center font-weight-bold">Excellent<br />5</th>
        </tr>
        <tr>
          <th className="align-middle font-weight-bold">Comprehension Skills</th>
          <td>The student has great difficulty understanding the content of reading and listening passages.</td>
          <td>The student has difficulty understanding some of the content of reading and listening passages.</td>
          <td>The student is somewhat able to comprehend and summarizes the content from the reading and listening passages.</td>
          <td>The student is able to comprehend and summarizes the content from the reading and listening passages.</td>
          <td>The student thoroughly comprehends and summarizes the content from the reading and listening passages.</td>
        </tr>
        <tr>
          <th className="align-middle font-weight-bold">Discourse</th>
          <td>The student uses little, if any, information from the two passages to present an opinion partially relevant and without supporting details.</td>
          <td>The student uses little information gathered from the two passages to present an opinion with one supporting detail.</td>
          <td>The student uses some information gathered from the at least one of the passages to present an opinion with relevant but simple supporting details. </td>
          <td>The student uses information gathered from the two passages to present a logical opinion with relevant supporting details.</td>
          <td>The student effectively uses information gathered from the two passages to present a logical opinion with relevant and well thought-out supporting details.</td>
        </tr>
        <tr>
          <th className="align-middle font-weight-bold">Language Use</th>
          <td>Grammar needs a great deal of improvement. The student’s vocabulary is far below average for the level.</td>
          <td>Grammar needs improvement. The student’s vocabulary is a little below average for the level.</td>
          <td>There are some grammar errors. The student’s vocabulary is somewhat high for the level.</td>
          <td>There are a few grammar errors. The student’s vocabulary is quite high for the level.</td>
          <td>There are almost no grammar errors. The student’s vocabulary is extremely high for the level.</td>
        </tr>
        <tr>
          <th className="align-middle font-weight-bold">Participation</th>
          <td>The student’s participation is minimal. The student needs to be continuously coerced or prompted to participate.</td>
          <td>The student participates in the debate with a little prompting from the teacher.</td>
          <td>The student participates in the debate somewhat actively.</td>
          <td>The student participates in the debate actively.</td>
          <td>The student participates in the debate very actively. No coercion or prompting is needed.</td>
        </tr>
      </table>

      <div className="border">
        • Grading Directions: Take a holistic approach when you assign a score. Consider the “average” of the student’s performance. For example, if the student demonstrates “Excellent” content, “Great” presentation, and “Good” delivery, then the student’s average would be “Great,” or a score of 4.
      </div>
    </Modal>
  );
}

export default ShowRublic3Modal;